import { type ReportDetail, getReportDetail } from '@/lib/api/reports-client.js';
import { useQuery } from '@tanstack/react-query';

export function useReportDetail(tenantReportId: string) {
  return useQuery<ReportDetail, Error>({
    queryKey: ['report', tenantReportId],
    queryFn: () => getReportDetail(tenantReportId),
    staleTime: 60_000,
    enabled: tenantReportId.length > 0,
  });
}
